import { Pipe, PipeTransform } from '@angular/core';
import { CustomerDto } from '@api';
import { DisplayNamePipe } from '@shared/pipes/display-name.pipe';

@Pipe({ name: 'detailedDisplayName' })
export class DetailedDisplayNamePipe implements PipeTransform {
  constructor(private defaultDisplayNamePipe: DisplayNamePipe) {}

  transform(value: CustomerDto | null | undefined, args?: any): string | null {
    if (!value) {
      return null;
    }
    return this.buildDetailedDisplayName(value);
  }

  private buildDetailedDisplayName(customer: CustomerDto): string {
    const defaultName = this.defaultDisplayNamePipe.transform(customer);

    const additionalInfo = [customer.id, customer.billingAddress?.zipCode, customer.billingAddress?.city].filter((o) => !!o);

    return `${defaultName} (${additionalInfo.join(', ')})`;
  }
}
